export default __webpack_public_path__ + "static/media/dog_vet_24x.0a60ed39.svg";